module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/operator-info.45432e86.svg";